import styled from '@emotion/styled';
import { getHumanReadableIntervalMillis } from '@racemap/utilities/functions/getHumanReadableInterval';

type Props = {
  intervalInMillis?: number;
  icon: React.ReactNode;
};

export const IntervalCell = ({ intervalInMillis, icon }: Props) => {
  return (
    <Interval>
      {intervalInMillis != null &&
        getHumanReadableIntervalMillis(intervalInMillis, { short: true })}
      <Icon hasInterval={intervalInMillis == null}>{icon}</Icon>
    </Interval>
  );
};

const Interval = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 55%;
`;

const Icon = styled.div<{ hasInterval: boolean }>`
  ${({ hasInterval }) => hasInterval && 'margin-left: auto;'}
`;
